const optFiles = require.context('./opt', true, /\.js$/)
const optMethods = optFiles.keys().reduce((methods, path) => {
	const moduleName = path.replace(/^\.\/(.*)\.\w+$/, '$1')
	const value = optFiles(path)
	methods[moduleName] = value.default
	return methods
}, {})

export default {
	sqlOpt:optMethods,
	isLoading: false//loading全局开关
}
